// extracted by mini-css-extract-plugin
module.exports = {"Categoryitem":"category_item_Categoryitem__2PKB1","Categoryitem1":"category_item_Categoryitem1__2JSZh","link":"category_item_link__3ahl1"};